import {Component} from "react"
import Logo from "./Logo"

class Footer extends Component<any> {
    render() {
        return (
            <footer id="footer" className="footer">
                <div className="footer-content">
                    <Logo />
                    <div className="footer-transparency">
                        <div className="footer-transparency-title">
                            How HomeIndex works
                        </div>
                        <span>
                            Sales data is sourced from the Irish Property Price Register.
                        </span>
                        <span>
                            Valuation estimates are based on recent comparable sales in the local area.
                        </span>
                    </div>
                    <div className="footer-links">
                        <a className="footer-link" href="/?path=/contact">Contact Us</a>
                        <a className="footer-link" href="/?path=/terms">Terms of Use</a>
                    </div>
                    <div className="footer-copyright">
                        © 2024 HomeIndex. All rights reserved.
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer
